import { safeStorage } from "../utils/storage";

// Rendered by the root Bugsnag ErrorBoundary when the app crashes, so it
// cannot rely on LanguageProvider (or any other context) being alive.
// Resolve the language the same way LanguageContext does and use a small
// inline dictionary instead of t().
const MESSAGES = {
  en: {
    title: "Something went wrong",
    body: "An unexpected error occurred. Reloading the page usually fixes it.",
    button: "Reload page",
  },
  es: {
    title: "Algo salió mal",
    body: "Se ha producido un error inesperado. Recargar la página suele solucionarlo.",
    button: "Recargar página",
  },
  de: {
    title: "Etwas ist schiefgelaufen",
    body: "Ein unerwarteter Fehler ist aufgetreten. Das Neuladen der Seite behebt das Problem meistens.",
    button: "Seite neu laden",
  },
  fr: {
    title: "Une erreur est survenue",
    body: "Une erreur inattendue s'est produite. Recharger la page résout généralement le problème.",
    button: "Recharger la page",
  },
  it: {
    title: "Qualcosa è andato storto",
    body: "Si è verificato un errore imprevisto. Ricaricare la pagina di solito risolve il problema.",
    button: "Ricarica la pagina",
  },
  el: {
    title: "Κάτι πήγε στραβά",
    body: "Παρουσιάστηκε ένα απρόσμενο σφάλμα. Η επαναφόρτωση της σελίδας συνήθως το διορθώνει.",
    button: "Επαναφόρτωση σελίδας",
  },
  pt: {
    title: "Algo correu mal",
    body: "Ocorreu um erro inesperado. Recarregar a página costuma resolver.",
    button: "Recarregar página",
  },
  tr: {
    title: "Bir şeyler ters gitti",
    body: "Beklenmeyen bir hata oluştu. Sayfayı yenilemek genellikle sorunu çözer.",
    button: "Sayfayı yenile",
  },
};

export default function ErrorFallback() {
  const lang =
    safeStorage.get("preferredLanguage") || navigator.language.split("-")[0];
  const m = MESSAGES[lang] || MESSAGES.en;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md text-center">
        <h2 className="text-5xl mb-4">😕</h2>
        <h3 className="text-lg font-medium text-gray-900">{m.title}</h3>
        <p className="mt-2 text-sm text-gray-500">{m.body}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-6 inline-flex items-center px-6 py-2.5 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-150"
        >
          {m.button}
        </button>
      </div>
    </div>
  );
}
